import { takeLatest, call, put, select } from 'redux-saga/effects';
import axios from 'axios';
import { checkCodeRequest, checkCodeSuccess, checkCodeFailure } from '../reducers/checkProjectCode';
import { API_LINK } from '../../constants';

const API = `${API_LINK}api/checkCoachProjectCode`;

function* checkCodeAxios() {

  const state = yield select(fullState => fullState);

  const {
    email,
    programCode,
    identityNo,
  } = state.form.registration.values;
  const response = yield call(() => {

  return axios({
    method: 'post',
    url: API,
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest',
    },
    credentials: 'same-origin',
    data: {
      
      email: email,
     
      projectCode: programCode,
      
      identityNo: identityNo,
     
      isCoach: 1,
    },
  });
});

  return response;
}

function* workerCheckCodeSaga() {
  
  try {
    const response = yield call(checkCodeAxios);
    const responseFromCheckCode = response.data;
  
    
    if (response.data.success === false) {
      console.log('CHECK_SAGA_2', response.data)
      yield put(checkCodeFailure(responseFromCheckCode));
    }else{
      console.log('CHECK_SAGA_3', response.data)
      yield put(checkCodeSuccess(responseFromCheckCode));
    }
  } catch (error) {
    console.log('CHECK_SAGA', error)
    yield put(checkCodeFailure(error));
  }
}

export function* watcherCheckCodeSaga() {
  yield takeLatest(checkCodeRequest().type, workerCheckCodeSaga);
}



// WEBPACK FOOTER //
// ./src/redux/sagas/checkCode.js